import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useAuthStore } from '@/app/store/auth.store';

import { myProfileApi } from '../api/my-profile.adapter';
import type { MyProfile } from '../api/my-profile.types';

export const myProfileQueryKeys = {
  all: ['my-profile'] as const,
  me: () => [...myProfileQueryKeys.all, 'me'] as const,
};

// Canonical fetch of the logged-in admin's profile (PRD 20 §13.1).
// Also hydrates the auth store so the GNB (email/isRoot) stays in sync with the
// authoritative response after each mount. Per Q1: fast hydration via login +
// canonical refetch via GET /auth/me on the page.
export function useMyProfileQuery() {
  const query = useQuery<MyProfile>({
    queryKey: myProfileQueryKeys.me(),
    queryFn: () => myProfileApi.getMe(),
    // The mock reads useAuthStore.email, so we only need the call once per mount.
    staleTime: 30_000,
  });

  const setProfile = useAuthStore((s) => s.setProfile);
  useEffect(() => {
    if (!query.data) return;
    setProfile({
      phone: query.data.phone,
      passwordChangedAt: query.data.passwordChangedAt,
      roles: query.data.roles,
      name: query.data.name,
    });
  }, [query.data, setProfile]);

  return query;
}
